import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { ToolbarDropdown, ToolbarSection } from "@components/Toolbar/ToolbarDropdown"
import PurchaseOrderSettingsEdit from "./PurchaseOrderSettingsEdit";



@inject("store")
@observer
class PurchaseOrderSettingsView extends React.Component {



    constructor(props) {
        super(props);

    }


    render() {
        const { store } = this.props;
        const orderStore = store.order;

        const headerClasses = [
            "header",

            this.headerExpanded ? "expanded" : null
        ];

        const footerClasses = [
            "footer",

            this.footerExpanded ? "expanded" : null
        ];

        const parentMatch = this.props.match;



        return (
            <ToolbarDropdown key={"order"} {...this.props} match={parentMatch}>

                <ToolbarSection>
                    <PurchaseOrderSettingsEdit />
                </ToolbarSection>
                <div className={footerClasses.join(' ')}>
                    {!orderStore.activeOrder ? null :
                        <React.Fragment>
                            <div className="row">

                                <div className="col-6">
                                    {orderStore.activeOrder && !orderStore.activeOrder.ReadOnly ?
                                        <button

                                            onClick={() => { this.props.store.navigation.openPurchaseOrder(); }}
                                            className="btn btn-sm btn-success my-0">
                                            {orderStore.activeOrder.OrderStatusId === 1 ?
                                                <span>
                                                    Tillbaka till inköpsorder
												</span>
                                                : <span>Submitted&nbsp;<i key="icon" className="material-icons check"></i></span>
                                            }

                                        </button>


                                        : null}
                                </div>
                                <div className="col-6 text-right">Sub total: <strong>{orderStore.activeOrder.SubTotalFormatted}</strong>
                                    <br />VAT: {orderStore.activeOrder.VATFormatted}
                                    <br />Total: {orderStore.activeOrder.OrderTotalFormatted}
                                </div>

                            </div>
                        </React.Fragment>
                    }

                </div>
            </ToolbarDropdown>
        );
    }
}



export default withRouter(PurchaseOrderSettingsView);